// Revival data hooks. The formatters live in revivalFormat (no API import, so a
// screen can print a quote without pulling in the client) and are re-exported here.
import { useCallback, useEffect, useState } from "react";
import revivalApi from "../../api/revivalApi";
import { rowsOf } from "./revivalFormat";

export * from "./revivalFormat";

/** Every live quote for the tenant. */
export function useRevivalQuotes() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    revivalApi
      .listQuotes()
      .then((res) => { if (alive) { setRows(rowsOf(res.data)); setError(""); } })
      .catch((err) => { if (alive) setError(err?.message ? `Couldn't load quotes: ${err.message}` : "Couldn't load quotes."); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [tick]);

  const reload = useCallback(() => setTick((t) => t + 1), []);
  const replace = useCallback((id, patch) => setRows((rs) => rs.map((r) => (String(r.id) === String(id) ? { ...r, ...patch } : r))), []);
  return { rows, loading, error, reload, replace };
}

/** The scanner summary (counts every scanner quote; the right number for "scanned"). */
export function useScanSummary() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    revivalApi
      .getSummary()
      .then((res) => { if (alive) setSummary(res.data || null); })
      .catch(() => { if (alive) setSummary(null); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);
  return { summary, loading };
}
